import { WarningAmber } from '@mui/icons-material'
import { SxProps, Theme, Typography } from '@mui/material'
import { FC, PropsWithChildren, ReactNode } from 'react'

import Button, { ButtonProps } from '../Button'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../Modal'

export interface ConfirmationModalProps {
  cancelButtonLabel?: string
  cancelButtonProps?: ButtonProps
  confirmButtonLabel?: string
  confirmButtonProps?: ButtonProps
  loading?: boolean
  open: boolean
  sx?: SxProps<Theme>
  title: ReactNode
  onCancel: (reason?: 'backdropClick' | 'escapeKeyDown') => void
  onConfirm: () => void
}

const ConfirmationModal: FC<PropsWithChildren<ConfirmationModalProps>> = ({
  cancelButtonLabel = 'Cancel',
  cancelButtonProps,
  children,
  confirmButtonProps,
  confirmButtonLabel = 'OK',
  loading,
  open,
  sx,
  title,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal open={open} sx={{ ...sx, zIndex: 9999 }} onClose={onCancel}>
      <ModalHeader icon={<WarningAmber color="warning" />}>{title}</ModalHeader>

      <ModalBody>
        <Typography component="div" sx={{ color: 'grey.600' }} variant="body2">
          {children}
        </Typography>
      </ModalBody>

      <ModalFooter>
        <Button variant="text" {...cancelButtonProps} disabled={loading} onClick={() => onCancel()}>
          {cancelButtonLabel}
        </Button>

        <Button
          className="save-btn"
          color="primary"
          variant="contained"
          {...confirmButtonProps}
          loading={loading}
          onClick={onConfirm}
        >
          {confirmButtonLabel}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmationModal
